webpackJsonp([22],{

/***/ 1036:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_manage_storage_js__ = __webpack_require__(1152);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf1b40b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_storage_vue__ = __webpack_require__(1374);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_manage_storage_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf1b40b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_storage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  listProduct: function listProduct(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  itemBarcode: function itemBarcode(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item/barcode', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  itemById: function itemById(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  itemAdd: function itemAdd(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      // console.log(error.response.data.error)
      error(response.response);
    });
  },
  itemUnit: function itemUnit(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item/unit', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  itemType: function itemType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item/type', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  itemGroup: function itemGroup(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  itemDepartment: function itemDepartment(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item/department', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  itemCatagory: function itemCatagory(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item/category', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  itemsALLGroup: function itemsALLGroup(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'product/v1/item/search/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  createReceive: function createReceive(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'receive/v1/create/receive', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  updateReceive: function updateReceive(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'receive/v1/update/receive', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  deleteReceive: function deleteReceive(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'receive/v1/remove/receive', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listReceive: function listReceive(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'receive/v1/list/receive', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getReceive: function getReceive(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'receive/v1/get/receive', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  createAdjust: function createAdjust(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/create/adjust', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getAdjust: function getAdjust(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/get/adjust', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listAdjust: function listAdjust(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/list/adjust', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  removeAdjust: function removeAdjust(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/remove/adjust', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  updateAdjust: function updateAdjust(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/update/adjust', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getTranfrom: function getTranfrom(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/get/tranform', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  createTranfrom: function createTranfrom(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/create/tranform', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listTranform: function listTranform(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/list/tranform', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  removeTranfrom: function removeTranfrom(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/remove/tranform', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  updateTranform: function updateTranform(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'adjust/v1/update/tranform', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  listAll: function listAll(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'vendor/v1/list/vendor', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  removeVendor: function removeVendor(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'vendor/v1/remove/vendor', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  AddVendor: function AddVendor(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'vendor/v1/add/vendor', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateVendor: function UpdateVendor(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'vendor/v1/update/vendor', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_item__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_vendor__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

/* eslint-disable eqeqeq */
/* eslint-disable camelcase */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      start_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()),
      end_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()),
      title: 'จัดการข้อมูลลูกหนี้',
      search: '',
      currentPage: 1,
      items_perpage: 1000,
      money_type: 1,
      modal_active: false,
      modal_data: {
        'item_code': '',
        'wh_id': 1,
        'wh_code': '01',
        'shelf_id': 1,
        'shelf_code': '01',
        'price': 0,
        'qty': 0,
        'avg_cost': 0,
        'lot_qty': 0,
        'unit_id': 0,
        'unit_code': '',
        'discount_word': '',
        'discount_amount': 0,
        'amount': 0,
        'stock_type': 0,
        'rate1': 1,
        'rate2': 1,
        'is_cancel': 0,
        'line_number': 0
      },
      monny_receive: 0,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      receive_item: {
        'ap_code': '',
        'tax_rate': 7,
        'bill_type': 0,
        'tax_type': 1,
        'bill_credit': 0,
        'doc_date': __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()),
        'due_date': __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()),
        'discount_word': '',
        'discount_amount': 0,
        'after_discount_amount': 0,
        'before_tax_amount': 0,
        'tax_amount': 0,
        'total_amount': 0,
        'cash_amount': 0,
        'change_amount': 0,
        'credit_card_amount': 0,
        'chq_amount': 0,
        'bank_amount': 0,
        'promt_pay_amount': 0,
        'bill_balance': 0,
        'is_pay_bill': 0,
        'sub': []
      },
      unit: [],
      catagory: [],
      code_receive: '',
      data_item: [],
      data_vender: [],
      item_detail: []
    };
  },

  components: {},
  computed: {
    filterData: function filterData() {
      var text = this.search.trim();
      this.currentPage = 1;
      return this.receive_item.sub.filter(function (items) {
        return items.item_code.indexOf(text) > -1;
      });
    },
    paginate: function paginate() {
      this.totalItem = this.filterData.length;
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1);
      }
      var index = (this.currentPage - 1) * this.items_perpage;
      return this.filterData.slice(index, index + this.items_perpage);
    }
  },
  methods: {
    handleChangeItem: function handleChangeItem(value, name) {
      console.log('selected ' + value);
      console.log('selected ' + name);
      this.modal_data.item_name = name;
      this.getItem(value);
    },
    handleChange: function handleChange(value) {
      console.log('selected ' + value);
    },
    handleChangeCus: function handleChangeCus(value) {
      console.log('selected ' + value);
      var start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date());
      this.receive_item.due_date = start_date.add(value.datacredit_day, 'days');
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.receive_item.due_date));
    },
    handleBlur: function handleBlur() {
      console.log('blur');
    },
    handleFocus: function handleFocus() {
      console.log('focus');
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    removeCus: function removeCus(index) {
      this.receive_item.sub.splice(index, 1);
    },
    addSub: function addSub() {
      var _this = this;

      var index = this.receive_item.sub.findIndex(function (x) {
        return x.item_code === _this.modal_data.item_code;
      });
      if (index < 0) {
        this.receive_item.sub.unshift(this.modal_data);
      } else {
        this.receive_item.sub[index] = this.modal_data;
      }
      this.modal_active = false;
      console.log(this.receive_item);
      this.calPriceAll();
    },
    editItem: function editItem(val) {
      // this.modal_data = {}
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
      this.modal_data = val;
      this.modal_active = true;
    },
    addItem: function addItem() {
      var temp_data = {
        'item_code': '',
        'item_name': '',
        'wh_id': 1,
        'wh_code': '01',
        'shelf_id': 1,
        'shelf_code': '01',
        'price': 0,
        'qty': 0,
        'avg_cost': 0,
        'lot_qty': 0,
        'unit_id': 0,
        'unit_code': '',
        'discount_word': '',
        'discount_amount': 0,
        'amount': 0,
        'stock_type': 0,
        // 'rate1': 1,
        // 'rate2': 1,
        'is_cancel': 0,
        'line_number': 0
      };
      this.modal_data = temp_data;
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.modal_data));
      this.modal_active = true;
    },
    close_modal: function close_modal() {
      this.modal_active = false;
    },
    itemCatagory: function itemCatagory() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_service_item__["a" /* default */].itemCatagory(this.REST_URL, this.header, {}, function (result) {
        if (result.response === 'success') {
          _this2.catagory = result.data;
        } else {
          _this2.$notification['warning']({
            message: 'ดึงข้อมูลหมวดหมู่ไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getUnit: function getUnit() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_service_item__["a" /* default */].itemUnit(this.REST_URL, this.header, {}, function (result) {
        console.log(result);
        if (result.response === 'success') {
          _this3.unit = result.data;
        } else {
          _this3.$notification['warning']({
            message: 'ดึงข้อมูลหน่วยนับไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    handleSubmit: function handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(function (err, values) {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    confirmPO: function confirmPO() {
      if (this.receive_item.ap_code == '' || this.receive_item.sub.length == 0) {
        this.$notification['warning']({
          message: 'กรุณากรอกข้อมูลให้ครบ'
        });
        return;
      }
      if (this.receive_item.doc_no) {
        this.updeteBill();
      } else {
        this.addBill();
      }
    },
    addBill: function addBill() {
      var _this4 = this;

      this.receive_item.doc_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.receive_item.doc_date).format('YYYY-MM-DD');
      this.receive_item.due_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.receive_item.due_date).format('YYYY-MM-DD');
      // switch (this.money_type) {
      //   case 1: this.receive_item.cash_amount = parseInt(this.monny_receive)
      //     break
      //   case 2: this.receive_item.credit_card_amount = parseInt(this.monny_receive)
      //     break
      //   case 3: this.receive_item.promt_pay_amount = parseInt(this.monny_receive)
      //     break
      //   case 4: this.receive_item.chq_amount = parseInt(this.monny_receive)
      //     break
      //   case 5: this.receive_item.bank_amount = parseInt(this.monny_receive)
      //     break
      // }
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.receive_item));
      __WEBPACK_IMPORTED_MODULE_1__services_service_item__["a" /* default */].createReceive(this.REST_URL, this.header, this.receive_item, function (result) {
        if (result.response === 'success') {
          _this4.$router.push('/receivelist');
          _this4.$notification['success']({
            message: 'บันทึกสำเร็จ',
            description: result.message
          });
        } else {
          _this4.$notification['warning']({
            message: 'ข้อมูลไม่ถูกต้อง',
            description: result.message
          });
        }
      }, function (error) {
        alert('เกิดข้อผิดพลาด ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    updeteBill: function updeteBill() {
      var _this5 = this;

      this.receive_item.doc_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.receive_item.doc_date).format('YYYY-MM-DD');
      this.receive_item.due_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.receive_item.due_date).format('YYYY-MM-DD');
      // switch (this.money_type) {
      //   case 1: this.receive_item.cash_amount = parseInt(this.monny_receive)
      //     break
      //   case 2: this.receive_item.credit_card_amount = parseInt(this.monny_receive)
      //     break
      //   case 3: this.receive_item.promt_pay_amount = parseInt(this.monny_receive)
      //     break
      //   case 4: this.receive_item.chq_amount = parseInt(this.monny_receive)
      //     break
      //   case 5: this.receive_item.bank_amount = parseInt(this.monny_receive)
      //     break
      // }
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.receive_item));
      __WEBPACK_IMPORTED_MODULE_1__services_service_item__["a" /* default */].updateReceive(this.REST_URL, this.header, this.receive_item, function (result) {
        if (result.response === 'success') {
          _this5.$router.push('/receivelist');
          _this5.$notification['success']({
            message: 'บันทึกสำเร็จ',
            description: result.message
          });
        } else {
          _this5.$notification['warning']({
            message: 'ข้อมูลไม่ถูกต้อง',
            description: result.message
          });
        }
      }, function (error) {
        alert('เกิดข้อผิดพลาด ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    calPriceSub: function calPriceSub() {
      this.modal_data.lot_qty = this.modal_data.qty;
      this.modal_data.amount = this.modal_data.avg_cost * this.modal_data.qty - this.modal_data.discount_amount;
    },
    calPriceAll: function calPriceAll() {
      var SubAmount = 0;
      for (var index = 1; index <= this.receive_item.sub.length; index++) {
        SubAmount += this.receive_item.sub[index - 1].amount;
      }
      this.receive_item.after_discount_amount = SubAmount - this.receive_item.discount_amount;
      console.log(this.receive_item.after_discount_amount);
      this.receive_item.tax_amount = this.receive_item.after_discount_amount * 0.07;
      this.receive_item.before_tax_amount = this.receive_item.after_discount_amount - this.receive_item.after_discount_amount * 0.07;
    },
    selectText: function selectText(val) {
      document.getElementById(val).select();
    },
    callReceive: function callReceive() {
      var _this6 = this;

      if (this.code_receive == '0') {
        console.log('New Receive');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__services_service_item__["a" /* default */].getReceive(this.REST_URL, this.header, {
        'doc_no': this.code_receive
      }, function (result) {
        console.log(result);
        if (result.response === 'success') {
          _this6.receive_item = result.data;
          _this6.receive_item.doc_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(result.data.doc_date);
          _this6.receive_item.due_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(result.data.due_date);
          if (_this6.receive_item.sub == null) {
            _this6.receive_item.sub = [];
          }
          // setTimeout(() => {
          //   if (result.data.cash_amount != 0) {
          //     this.monny_receive = result.data.cash_amount
          //   } else if (result.data.credit_card_amount != 0) {
          //     this.monny_receive = result.data.credit_card_amount
          //   } else if (result.data.chq_amount != 0) {
          //     this.monny_receive = result.data.chq_amount
          //   } else if (result.data.bank_amount != 0) {
          //     this.monny_receive = result.data.bank_amount
          //   } else if (result.data.promt_pay_amount != 0) {
          //     this.monny_receive = result.data.promt_pay_amount
          //   }
          // }, 500)
          console.log(_this6.receive_item);
        } else {
          _this6.$notification['error']({
            message: 'ดึงข้อมูลไม่ได้',
            description: result
          });
        }
      }, function (error) {
        console.log(error);
        _this6.$notification['error']({
          message: 'ดึงข้อมูลไม่ได้',
          description: error.data.error
        });
        // alert('ไม่สามารถเข้าถึงข้อมูล ' + error)
      });
    },
    addUnit: function addUnit(val) {
      var index = this.unit.find(function (x) {
        return x.id == val;
      });
      console.log(index);
      if (index == null) {} else {
        this.modal_data.unit_code = index.unit_code;
      }
      // this.modal_data.unit_code = val
      // console.log(this.modal_data.unit_code)
    },
    getProductAll: function getProductAll() {
      var _this7 = this;

      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_1__services_service_item__["a" /* default */].listProduct(this.REST_URL, this.header, {}, function (result) {
        if (result.response === 'success') {
          // console.log(result)
          _this7.data_item = result.data;
        } else {
          _this7.$notification['warning']({
            message: 'ดึงข้อมูลลูกหนี้',
            description: result.message
          });
        }
        _this7.$store.commit('Loading');
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getVenderAll: function getVenderAll() {
      var _this8 = this;

      this.$store.commit('Loading');
      var body = {
        'keyword': '',
        'limit': 1000000,
        'status': 1
      };
      __WEBPACK_IMPORTED_MODULE_2__services_service_vendor__["a" /* default */].listAll(this.REST_URL, this.header, body, function (result) {
        if (result.response === 'success') {
          _this8.data_vender = result.data;
        } else {
          _this8.$notification['warning']({
            message: 'ดึงข้อมูลเจ้าหนี้',
            description: result.message
          });
        }
        _this8.$store.commit('Loading');
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getItem: function getItem(val) {
      var _this9 = this;

      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_1__services_service_item__["a" /* default */].itemById(this.REST_URL, this.header, { 'id': parseInt(val) }, function (result) {
        if (result.response === 'success') {
          // console.log(JSON.stringify(result))
          _this9.modal_data.price = result.data.bar_data[0].price_1;
          _this9.modal_data.unit_id = result.data.stk_unit_id;
          _this9.modal_data.unit_code = result.data.stk_unit_code;
          _this9.modal_data.stock_type = result.data.stock_type;
        } else {
          _this9.$notification['warning']({
            message: 'ดึงข้อมูลไม่ได้',
            description: result.message
          });
        }
        _this9.$store.commit('Loading');
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this9.$store.commit('Loading');
      });
    },
    printBill: function printBill() {
      this.$notification['warning']({
        message: 'แจ้งปัญหา',
        description: 'กำลังปรับปรุง'
      });
    }
  },
  created: function created() {
    this.checkUser();
    this.code_receive = this.$route.params.code;
    this.getUnit();
    this.itemCatagory();
    this.callReceive();
    this.getVenderAll();
  },
  mounted: function mounted() {
    this.getProductAll();
    console.log(this.$store.state.currentPath);
    console.log(this.$store.state.historyPage);
  }
});

/***/ }),

/***/ 1374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3",style:({ 'min-height' : _vm.$store.state.screenHeight - 100 + 'px' })},[_c('div',{staticClass:"card-body text-center"},[_c('div',{staticClass:"container row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-right ml-5"},[_c('button',{staticClass:"col text-left pt-1 btn btn-primary",staticStyle:{"font-size":"25px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.addItem()}}},[_c('i',{staticClass:"fas fa-cart-plus"}),_vm._v(" เพิ่มสินค้า\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"container row",staticStyle:{"justify-content":"space-between"}},[_c('div',{staticClass:"form-group row",staticStyle:{"width":"35%"}},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("เลขที่เอกสาร :")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.receive_item.doc_no),expression:"receive_item.doc_no",modifiers:{"number":true}}],staticClass:"form-control text-left",attrs:{"id":"pricebill","type":"text","placeholder":"เลขที่เอกสาร....","disabled":""},domProps:{"value":(_vm.receive_item.doc_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.receive_item, "doc_no", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"width":"35%"}},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("เจ้าหนี้ :")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('a-select',{staticStyle:{"width":"100%"},attrs:{"showSearch":"","placeholder":"รหัสเจ้าหนี้...","optionFilterProp":"children","filterOption":_vm.filterOption},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur,"change":_vm.handleChange},model:{value:(_vm.receive_item.ap_code),callback:function ($$v) {_vm.$set(_vm.receive_item, "ap_code", $$v)},expression:"receive_item.ap_code"}},_vm._l((_vm.data_vender),function(vd,j){return _c('a-select-option',{key:j,attrs:{"value":vd.code},on:{"click":function($event){return _vm.handleChangeCus(vd)}}},[_vm._v("\n              "+_vm._s(vd.code +"/"+ vd.name)+"\n            ")])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"width":"35%"}},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("วันที่ออก :")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('a-date-picker',{staticClass:"form-control",attrs:{"format":'DD/MM/YYYY',"id":"date"},model:{value:(_vm.receive_item.doc_date),callback:function ($$v) {_vm.$set(_vm.receive_item, "doc_date", $$v)},expression:"receive_item.doc_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"width":"35%"}},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ประเภทเงิน :")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.money_type),expression:"money_type"}],staticClass:"form-control",attrs:{"id":"shift"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.money_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":1}},[_vm._v("เงินสด")]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("บัตรเครดิต")]),_vm._v(" "),_c('option',{domProps:{"value":3}},[_vm._v("พร้อมเพย์")]),_vm._v(" "),_c('option',{domProps:{"value":4}},[_vm._v("เช็ค")]),_vm._v(" "),_c('option',{domProps:{"value":5}},[_vm._v("เงินโอน")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"width":"35%"}},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ประเภทบิล :")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.receive_item.bill_type),expression:"receive_item.bill_type",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"id":"shift"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.receive_item, "bill_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v("บิลเงินสด")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("บิลเงินเชื่อ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"width":"35%"}},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("วันหมดอายุ :")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('a-date-picker',{staticClass:"form-control",attrs:{"format":'DD/MM/YYYY',"id":"date"},model:{value:(_vm.receive_item.due_date),callback:function ($$v) {_vm.$set(_vm.receive_item, "due_date", $$v)},expression:"receive_item.due_date"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',[_vm._l((_vm.paginate),function(d,i){return _c('tr',{key:'cus' + i},[_c('th',{staticClass:"text-center align-middle p-1"},[_vm._v("\n              "+_vm._s(_vm.items_perpage * _vm.currentPage - (_vm.items_perpage - i) + 1)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-left align-middle p-1"},[_vm._v(_vm._s(d.item_code+'/'+d.item_name))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle p-1"},[_vm._v(_vm._s(d.wh_code+'/'+d.shelf_code))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle p-1"},[_vm._v(_vm._s(d.unit_code))]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle p-1"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.avg_cost)))]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle p-1"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle p-1"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.amount)))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle p-1"},[_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.editItem(d)}}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeCus(i)}}},[_c('i',{staticClass:"fas fa-times"})])])])}),_vm._v(" "),_c('tr',[(_vm.receive_item.sub.length < 1)?_c('th',{staticClass:"text-center",attrs:{"scope":"row","colspan":"10"}},[_vm._v("\n              ไม่มีข้อมูล\n            ")]):_vm._e()])],2)])]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","width":"35%"}},[_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ส่วนลด :")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.receive_item.discount_amount),expression:"receive_item.discount_amount",modifiers:{"number":true}}],staticClass:"form-control text-right",attrs:{"id":"discount_amount","type":"number","placeholder":"ส่วนลด...."},domProps:{"value":(_vm.receive_item.discount_amount)},on:{"click":function($event){return _vm.selectText('discount_amount')},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.receive_item, "discount_amount", _vm._n($event.target.value))},function($event){return _vm.calPriceAll()}],"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("มูลค่าก่อนภาษี :")]),_vm._v(" "),_c('div',{staticClass:"col-8 text-right"},[_c('label',{staticClass:"col-form-label"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.receive_item.before_tax_amount) + ' บาท'))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("มูลค่าภาษี :")]),_vm._v(" "),_c('div',{staticClass:"col-8 text-right",staticStyle:{}},[_c('label',{staticClass:"col-form-label"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.receive_item.tax_amount) + ' บาท')+" ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-4 text-left col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("มูลค่าสุทธิ :")]),_vm._v(" "),_c('div',{staticClass:"col-8 text-right",staticStyle:{}},[_c('label',{staticClass:"col-form-label"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.receive_item.after_discount_amount) + ' บาท'))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end",attrs:{"id":"components-pagination-demo-mini"}},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.confirmPO()}}},[_c('i',{staticClass:"fas fa-file-alt"}),_vm._v(" บันทึก")])])])]),_vm._v(" "),_c('a-modal',{attrs:{"title":"เพิ่มสินค้ารับเข้า","centered":""},on:{"ok":function($event){return _vm.addSub()},"cancel":function($event){return _vm.close_modal()}},model:{value:(_vm.modal_active),callback:function ($$v) {_vm.modal_active=$$v},expression:"modal_active"}},[_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-select',{staticClass:"col-sm-12",attrs:{"showSearch":"","placeholder":"รหัสสินค้า...","optionFilterProp":"children","filterOption":_vm.filterOption},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur},model:{value:(_vm.modal_data.item_code),callback:function ($$v) {_vm.$set(_vm.modal_data, "item_code", $$v)},expression:"modal_data.item_code"}},_vm._l((_vm.data_item),function(it,j){return _c('a-select-option',{key:j,attrs:{"value":it.code},on:{"click":function($event){return _vm.handleChangeItem(it.id, it.name)}}},[_vm._v("\n              "+_vm._s(it.code +"/"+ it.name)+"\n            ")])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ประเภทสต๊อก")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modal_data.stock_type),expression:"modal_data.stock_type"}],staticClass:"form-control",attrs:{"id":"shift","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modal_data, "stock_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}}),_vm._v(" "),_c('option',{domProps:{"value":0}},[_vm._v("ทั่วไป")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("บริการ")]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("สินค้าชุด")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_credit"}},[_vm._v("ราคา/หน่วย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.modal_data.price),expression:"modal_data.price",modifiers:{"number":true}}],staticClass:"form-control text-right",attrs:{"id":"sub_price","type":"number","placeholder":"ราคา....","disabled":""},domProps:{"value":(_vm.modal_data.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal_data, "price", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ต้นทุน/หน่วย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.modal_data.avg_cost),expression:"modal_data.avg_cost",modifiers:{"number":true}}],staticClass:"form-control text-right",attrs:{"id":"sub_avg","type":"number","placeholder":"ต้นทุน..."},domProps:{"value":(_vm.modal_data.avg_cost)},on:{"click":function($event){return _vm.selectText('sub_avg')},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal_data, "avg_cost", _vm._n($event.target.value))},function($event){return _vm.calPriceSub()}],"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_credit"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.modal_data.qty),expression:"modal_data.qty",modifiers:{"number":true}}],staticClass:"form-control text-right",attrs:{"id":"sub_qty","type":"number","placeholder":"จำนวน...."},domProps:{"value":(_vm.modal_data.qty)},on:{"click":function($event){return _vm.selectText('sub_qty')},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal_data, "qty", _vm._n($event.target.value))},function($event){return _vm.calPriceSub()}],"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("หน่วยนับ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.modal_data.unit_id),expression:"modal_data.unit_id",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"id":"shift","onclick":_vm.addUnit(_vm.modal_data.unit_id),"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.modal_data, "unit_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.unit),function(un,j){return _c('option',{key:j,domProps:{"value":un.id}},[_vm._v(_vm._s(un.unit_code))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ส่วนลด")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.modal_data.discount_amount),expression:"modal_data.discount_amount",modifiers:{"number":true}}],staticClass:"form-control text-right",attrs:{"id":"sub_discount","type":"text","placeholder":"ส่วนลด..."},domProps:{"value":(_vm.modal_data.discount_amount)},on:{"click":function($event){return _vm.selectText('sub_discount')},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal_data, "discount_amount", _vm._n($event.target.value))},function($event){return _vm.calPriceSub()}],"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ราคารวม")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modal_data.amount),expression:"modal_data.amount"}],staticClass:"form-control text-right",attrs:{"disabled":"","type":"text","placeholder":"ราคารวม..."},domProps:{"value":(_vm.modal_data.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal_data, "amount", $event.target.value)}}})])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left row"},[_c('h1',{staticClass:"col text-left pt-1",staticStyle:{"font-weight":"bold"}},[_vm._v("ระบบบริหารสินค้าคงคลัง")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-dark"},[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("รหัส/ชื่อ")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("คลัง/ชั้นเก็บ")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("ต้นทุน")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("ราคา")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("แก้ไข")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.2498f8a249664c267720.js